import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';
import { StrictHttpResponse as __StrictHttpResponse } from '../data/model/generic/strict-http.response';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SecurityProvider } from '../providers/security.provider';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(protected http: HttpClient,) { }

  
  getLocalIp =() => {
    return new Promise<string>((resolve, reject) => {
      try {
        this.http.jsonp('https://ipinfo.io?token=50b717f2a26377', 'callback').subscribe((data:any) => {
          resolve(data.ip);
        });
      } catch (error) {
        reject("0.0.0.0");
      }
    });
    // let response = this.getLocalIpResponse();
    
    // return response.pipe(__map(_r=> _r.body as IpModel));
  }

  static addHeaders(req: HttpRequest<any>, headers?: { [key: string]: string } | null): HttpRequest<any> {
    let h = <any>{};
    for(var name in req.headers.keys) {
      h[name] = req.headers.get(name);
    }
    if (headers) {
      for (const key of Object.keys(headers)) {
        h[key] =  headers[key];
      }
    }
    h['X-TRACK-HEADER'] = SecurityProvider.hash(JSON.stringify(req.body));
    
    return req.clone({setHeaders: h});
  }


  static requestApi<P, R>(http: HttpClient,init: {
      method: string,
      parameters?: P,
      headers?: { [key: string]: string } | null,
      url: string
    }): Observable<__StrictHttpResponse<R>> {
    let __headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', 'Bearer '+localStorage.getItem(environment.nameAccessToken));

      let req = new HttpRequest<any>(init!.method, `${environment.serverUrl+init!.url}` , init!.parameters, {
        responseType: "json",
        headers: __headers
    });

    req = this.addHeaders(req, init?.headers);

    return http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map(_r => {
        return _r as __StrictHttpResponse<R>;
      })
    );
  }


  static requestApiWhitOutAuthorization<P, R>(http: HttpClient,init: {
    method: string,
    parameters?: P,
    headers?: { [key: string]: string } | null,
    url: string
  }): Observable<__StrictHttpResponse<R>> {
  let __headers = new HttpHeaders()
    .set('Content-Type', 'application/json');

    let req = new HttpRequest<any>(init!.method, `${environment.serverUrl+init!.url}` , init!.parameters, {
      responseType: "json",
      headers: __headers
  });

  req = this.addHeaders(req, init?.headers);

  return http.request<any>(req).pipe(
    __filter(_r => _r instanceof HttpResponse),
    __map(_r => {
      return _r as __StrictHttpResponse<R>;
    })
  );
}
}
